import { isNil, pick, values } from 'lodash';
import { RelapsePreventionDetails } from '../Types';
import useEditState from './useEditState';
import { EpisodeTreatmentProgram } from '~/lib/constants/patients.constants';
import { useEffect } from 'react';

export const useEditRelapsePreventionState = (
  treatmentEpisode?: TreatmentEpisode,
) => {
  let initialState: RelapsePreventionDetails | null = null;
  if (treatmentEpisode) {
    const found = treatmentEpisode.treatmentPrograms?.find(
      (p) =>
        p.treatmentProgramName === EpisodeTreatmentProgram.RELAPSE_PREVENTION,
    );
    if (found) {
      initialState = found;
    } else if (
      treatmentEpisode.treatmentProgramName ===
      EpisodeTreatmentProgram.RELAPSE_PREVENTION
    ) {
      initialState = {
        end: null,
        start: null,
      };
    }
  }
  const { reset, ...state } = useEditState<RelapsePreventionDetails>(
    initialState,
    (data) => values(pick(data, ['start'])).some(isNil),
  );

  const resetState = (state?: RelapsePreventionDetails) => {
    reset(
      state
        ? {
            end: state.end,
            start: state.start,
          }
        : initialState,
    );
  };

  useEffect(() => {
    resetState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treatmentEpisode]);

  return {
    resetState,
    ...state,
  };
};
